import { render, staticRenderFns } from "./FileStsTrailer.vue?vue&type=template&id=51c6a7f8&scoped=true&"
import script from "./FileStsTrailer.vue?vue&type=script&lang=js&"
export * from "./FileStsTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6a7f8",
  null
  
)

export default component.exports